/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.slickSlider = function () {

    var slider = '.js-gallery-slider';
    var thumbItem = '.c-gallery__thumbnail';
    $(thumbItem).each(function () {
      var index = $(thumbItem).index(this);
      $(this).attr("data-index", index);
    });

    $(slider).on('init', function (slick) {
      var index = $('.slide-item.slick-slide.slick-current').attr("data-slick-index");
      $(thumbItem + '[data-index="' + index + '"]').addClass('thumb-current');
    });
    //スライダー初期化
    $(slider).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      // asNavFor: '.js-work-thumb',
      centerMode: true,
      centerPadding: '30.3%',
      accessibility: false,
      dots: true,
      appendDots: '.c-gallery__thumbnails',
      arrows: true,
      appendArrows: '.c-gallery__thumbnails',
      nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/intertecinc-html/dist/assets/images/icon-gallery-slider-next@2x.png"></button>',
      prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/intertecinc-html/dist/assets/images/icon-gallery-slider-prev@2x.png"></button>',
      responsive: [
        {
          breakpoint: 750,
          settings: {
            centerPadding: '16px',
          }
        },
        {
          breakpoint: 1600,
          settings: {
            centerPadding: '23.3%',
          }
        },
      ]
    });
    //サムネイルをクリックした時スライダー切り替え
    $(thumbItem).on('click', function () {
      var index = $(this).attr("data-index");
      $(slider).slick("slickGoTo", index, false);

    });

    //サムネイル画像のカレントを切り替え
    $(slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $(thumbItem).each(function () {
        $(this).removeClass("thumb-current");
      });
      $(thumbItem + '[data-index="' + nextSlide + '"]').addClass("thumb-current");
    });
  }

  $(function () {
    var app = new growApp();
    app.slickSlider();
  });
})(jQuery);
